import PanelTitle from './PanelTitle';
export * from './PanelTitle';
export default PanelTitle;
